import React from 'react';
import {
  IMediaGalleryItem,
  SlideDescription,
} from '@hotelplan/core.serving.bs-rsv-gallery';

export interface ISlideInfoProps<T extends IMediaGalleryItem> {
  item?: T | undefined;
  className?: string;
  isHideBackground?: boolean;
}

function FdrGeoProductGallerySlideInfo<T extends IMediaGalleryItem>(
  props: ISlideInfoProps<T>
): React.ReactElement | null {
  const { item, className, isHideBackground = false } = props;

  if (!item) {
    return null;
  }

  return (
    <>
      <SlideDescription
        className={className}
        isHideBackground={isHideBackground}
      >
        <p>
          {item.title && <span className="slide-title">{item.title}</span>}
          <span className="slide-title-disruptor"> - </span>
          {item.image.description && (
            <span className="slide-description">{item.image.description}</span>
          )}
        </p>
      </SlideDescription>
    </>
  );
}

export default FdrGeoProductGallerySlideInfo;
